import axios from "axios"
import { AppServices, HttpHeaders } from "../Services/AppServices";

const InvesterServices = {
    getInvestors: ({ per_page = 10, page = 1, search = '', sort_by = '', sort_order = '', status }) => {
        return axios.get(AppServices.GET_INVESTORES(), {
            headers: HttpHeaders().headers,
            params: {            
                per_page,
                page,
                search,
                sort_by,
                sort_order,
                status
            }
        });
    },
    saveInvestor: (data) => {
        if (data.investorId) {
            return axios.post(AppServices.UPDATE_INVESTOR(data.investorId), data, HttpHeaders())
        }
        else {
            return axios.post(AppServices.SAVE_INVESTOR(), data, HttpHeaders())
        }
    },
    getInvestor: (investorId) => {
        return axios.get(AppServices.GET_INVESTOR(investorId), HttpHeaders())
    },
    deleteInvestor: (data) => {
        return axios.post(AppServices.DELETE_INVESTOR(data.investorId), data, HttpHeaders())
    },
    restoreInvestor: (data) => {
        return axios.post(AppServices.RESTORE_INVESTOR(data.investorId), data, HttpHeaders())
    },
}
export default InvesterServices;
